import { defaultMultipleSelectProps, ValueContainer } from "components/shared/select";
import { paths } from "helpers/paths";
import { reportFilterWrapper, SelectColumnFilter } from "helpers/reactTable";
import { formatValue, typeSpecificProps } from "helpers/reports";
import { matchSorter } from "match-sorter";
import Tooltip from "rc-tooltip";
import React from "react";
import { list as logistsList } from "sources/books/employees";
import PlanFactReport from "./planFactReport";

export default class EmptyMileageBidsPlanFactReport extends PlanFactReport {
    formatData = (data) => {
        const result = [];
        data.forEach((row) => {
            const { car, carLogistId, carLogistDisplayName } = row;
            if (row.bids.length > 0) {
                row.bids.forEach((bidRow) => {
                    result.push({ ...bidRow, car, carLogistId, carLogistDisplayName });
                });
            } else {
                result.push({ car, carLogistId, carLogistDisplayName, isEmpty: true });
            }
        });
        return result;
    };

    extractColumns = () => {
        return [
            {
                Header: "Логист",
                accessor: "carLogistId",
                Filter: reportFilterWrapper((props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            ...defaultMultipleSelectProps,
                            url: logistsList,
                            inputProps: { name: "carLogistIds" },
                            propName: "fullNameOrEmail",
                            components: { ValueContainer },
                        }}
                    />
                )),
                filter: (rows, _id, filterValue) => {
                    if (!filterValue || !filterValue.value || filterValue.value.length === 0) {
                        return rows;
                    }
                    return rows.filter((row) => filterValue.value.includes(row.values.carLogistId));
                },
                Cell: (props) => {
                    const { subRows } = props.row;
                    return subRows[0].subRows[0].original.carLogistDisplayName || "Без логиста";
                },
            },
            {
                Header: "Машина",
                accessor: "car",
                Aggregated: () => "",
                filterable: true,
                filter: (rows, _id, filterValue) => {
                    if (!filterValue || !filterValue.value) {
                        return rows;
                    }
                    return rows.filter(
                        (row) =>
                            matchSorter([row.values.car], filterValue.value, {
                                threshold: matchSorter.rankings.CONTAINS,
                            }).length !== 0,
                    );
                },
                Cell: (props) => {
                    const { subRows } = props.row;
                    return (
                        <span data-car={subRows[0].original.carNumber}>
                            {props.value} {subRows && !subRows[0].original.isEmpty && `(${subRows.length})`}
                        </span>
                    );
                },
            },
            {
                Header: "Заявка",
                accessor: "bidId",
                filterable: true,
                filterMethod: (filter, row) => {
                    return (
                        row._groupedByPivot ||
                        matchSorter([(row.bidId || "").toString()], filter.value, {
                            threshold: matchSorter.rankings.CONTAINS,
                        }).length !== 0
                    );
                },
                Cell: ({ value, row: { original } }) => (
                    <>
                        <a
                            data-bidid={value}
                            href={paths.bidShow("bid", value)}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {value}
                        </a>
                        {original.hasCarChange && (
                            <Tooltip overlay="Произошла смена машины">
                                <span
                                    className="pl-1 icon-uEAB3-arrows-rotate b-point__tooltip-icon"
                                    data-for={`carChange${value}`}
                                />
                            </Tooltip>
                        )}
                        {original.hasEmulatedMileage && (
                            <Tooltip overlay="В заявке присутствуют сэмулированные участки маршрута">
                                <i className="pl-1 icon-uEACB-emulated-route b-point__tooltip-icon" />
                            </Tooltip>
                        )}
                    </>
                ),
                Aggregated: () => "",
            },
            {
                Header: "Внешний ID Заявки",
                accessor: "externalBidId",
                ...typeSpecificProps({}),
                Cell: ({ value }) => value,
                Aggregated: () => "",
            },
            {
                Header: "Плановый пробег",
                accessor: "planMileage",
                Aggregated: ({ value }) => <strong>{formatValue(value, "double")}</strong>,
                aggregate: "sum",
                Cell: ({ value, row: { values } }) => (
                    <span data-planmileage={values.bidId}>{formatValue(value, "double")}</span>
                ),
            },
            {
                Header: "Фактический пробег",
                accessor: "factMileage",
                Aggregated: ({ value }) => <strong>{formatValue(value, "double")}</strong>,
                aggregate: "sum",
                Cell: ({ value, row: { values } }) => (
                    <span data-factmileage={values.bidId}>{formatValue(value, "double")}</span>
                ),
            },
        ];
    };

    tableExtraProps = () => ({
        initialState: {
            groupBy: ["carLogistId", "car"],
        },
        data: this.formatData(this.props.data.data),
    });
}
